import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@onefootprint/ui';
import { type ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePdfCapture from './use-pdf-capture';
type ExportPdfDialogProps = {
  children: ReactNode;
  filename: string;
  onClose: () => void;
  open: boolean;
  title: string;
};
const ExportPdfDialog = t0 => {
  const $ = _c(25);
  const {
    children,
    filename,
    onClose,
    open,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.pdfExport"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const capturePdf = usePdfCapture();
  const docRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);
  let t2;
  if ($[1] !== capturePdf || $[2] !== filename) {
    t2 = async () => {
      const el = docRef.current;
      if (!el) {
        return;
      }
      setIsExporting(true);
      await capturePdf(el, {
        filename
      });
      setIsExporting(false);
    };
    $[1] = capturePdf;
    $[2] = filename;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDownload = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleDownload || $[7] !== isExporting || $[8] !== t3) {
    t4 = {
      label: t3,
      loading: isExporting,
      onClick: handleDownload
    };
    $[6] = handleDownload;
    $[7] = isExporting;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp2);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isExporting || $[13] !== onClose || $[14] !== t5) {
    t6 = {
      label: t5,
      onClick: onClose,
      disabled: isExporting
    };
    $[12] = isExporting;
    $[13] = onClose;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== children) {
    t7 = <div className="bg-secondary p-4 min-h-full overflow-x-auto md:p-6 md:overflow-x-visible"><div className="mx-auto w-[760px] shadow-md md:w-auto md:max-w-[760px]"><div ref={docRef}>{children}</div></div></div>;
    $[16] = children;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== onClose || $[19] !== open || $[20] !== t4 || $[21] !== t6 || $[22] !== t7 || $[23] !== title) {
    t8 = <Dialog title={title} open={open} onClose={onClose} size="large" noPadding={true} primaryButton={t4} secondaryButton={t6}>{t7}</Dialog>;
    $[18] = onClose;
    $[19] = open;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
    $[23] = title;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default ExportPdfDialog;
function _temp($) {
  return $.download;
}
function _temp2($_0) {
  return $_0.close;
}